<script>
export default {
  name: 'TwTimeStamp',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hourLabel: {
      type: String,
      default: null,
    },
    minuteLabel: {
      type: String,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    minuteStep: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    hours() {
      const options = [];
      for (let hour = 0; hour <= 23; hour++) {
        options.push({
          text: hour.toString().padStart(2, '0'),
          value: hour,
        });
      }
      return options;
    },
    minutes() {
      const options = [];
      for (let minute = 0; minute < 60; minute += this.minuteStep) {
        options.push({
          text: minute.toString().padStart(2, '0'),
          value: minute,
        });
      }
      return options;
    },
    currentHour() {
      if (!this.value) return null;
      const parts = this.value.split(':');
      return parts.length >= 1 ? parseInt(parts[0], 10) : null;
    },
    currentMinute() {
      if (!this.value) return null;
      const parts = this.value.split(':');
      return parts.length >= 2 ? parseInt(parts[1], 10) : null;
    },
  },
  methods: {
    onHourChange(hour) {
      const minute = this.currentMinute || 0;
      this.updateTime(hour, minute);
    },
    onMinuteChange(minute) {
      const hour = this.currentHour || 0;
      this.updateTime(hour, minute);
    },
    updateTime(hour, minute) {
      const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      this.$emit('input', timeString);
    },
  },
};
</script>

<template>
  <div class="tw-time-stamp">
    <v-select
      :value="currentHour"
      :items="hours"
      :label="hourLabel"
      :disabled="disabled"
      :readonly="readonly"
      :dense="dense"
      :outlined="outlined"
      :filled="filled"
      :hide-details="hideDetails"
      item-text="text"
      item-value="value"
      @input="onHourChange"
    />

    <span class="time-separator">:</span>

    <v-select
      :value="currentMinute"
      :items="minutes"
      :label="minuteLabel"
      :disabled="disabled"
      :readonly="readonly"
      :dense="dense"
      :outlined="outlined"
      :filled="filled"
      :hide-details="hideDetails"
      item-text="text"
      item-value="value"
      @input="onMinuteChange"
    />
  </div>
</template>

<style scoped>
.tw-time-stamp {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.time-separator {
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
  user-select: none;
  text-align: center;
  line-height: 1;
}
</style>




// WEBPACK FOOTER //
// src/components/TwTimeStamp.vue